var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dean-spinner"},[_c('dean-icon',{staticClass:"dean-spinner-icon",attrs:{"glyph":_vm.spinnerType,"height":_vm.size,"width":_vm.size}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }